import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const url = "https://redemeaiyg.execute-api.us-east-1.amazonaws.com/user";
const LoginQuery = `
  query login($input: loginInput!){
    login(input: $input) {
        status
        errors
        token
    }
  }
`;

const RegisterQuery = `
  mutation signup($input: NewUser!) {
    registerNewUser(input: $input) {
        status,
        errors,
        data {
            token
        }
    }
  }
`;


export const loginUser = createAsyncThunk("user/login", async (loginData: { email: String, password: String }) => {
  const graphqlQuery = {
    query: LoginQuery,
    variables: { input: loginData }
  }
  const response = await axios.post(url, graphqlQuery)
  return response.data.data.login;
});

export const registerUser = createAsyncThunk("user/register", async (registerData: { email: String, password: String, fullName: String }) => {
  const graphqlQuery = {
    query: RegisterQuery,
    variables: { input: registerData }
  }
  const response = await axios.post(url, graphqlQuery)
  console.log(response.data.data.registerNewUser)
  return response.data.data.registerNewUser;
});

interface InitialState {
  token: string | null;
  errors: [string] | null;
  status: "idle" | "loading" | "succeeded" | "failed";
}

let tokenInStorage = localStorage.getItem("token");
let token;
if (!tokenInStorage || tokenInStorage === "null" || tokenInStorage === "undefined") {
  token = null;
  localStorage.removeItem("token");
} else {
  token = tokenInStorage;
}

const initialState: InitialState = {
  token,
  status: "idle",
  errors: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state: InitialState) => {
      state.token = null;
      state.errors = null;
      state.status = "succeeded";
      localStorage.removeItem("token");
    }
  },
  extraReducers(builder) {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.token = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        const { status } = action.payload;
        if (status > 199 && status < 300) {
          state.status = "succeeded";
          // save token to local storage
          localStorage.setItem("token", action.payload.token);
          state.token = action.payload.token;
        } else {
          state.errors = action.payload.errors;
          state.status = "failed";
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.errors?.push(action.error.message!);
      }).addCase(registerUser.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.token = null;
      }).addCase(registerUser.fulfilled, (state, action) => {
        const { status } = action.payload;
        if (status > 199 && status < 300) {
          state.status = "succeeded";
          // save token to local storage
          localStorage.setItem("token", action.payload.data.token);
          state.token = action.payload.data.token;
        } else {
          state.errors = action.payload.errors;
          state.status = "failed";
        }
      }).addCase(registerUser.rejected, (state, action) => {
        state.status = "failed";
        state.errors?.push(action.error.message!);
      });
  },
});

export const { logout } = userSlice.actions;

export default userSlice.reducer;
